import apiinfo from "../../../../utils/base-uri.json";
import { useForm } from "react-hook-form";
import OutlinedInput from "@mui/material/OutlinedInput";
import {
  FormControl,
  Select,
  MenuItem,
  Tooltip,
  Button,
  TextField,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "../../../../utils/fvAxios";
import { format } from "mathjs";
import { getGlobalClientId, getToken,getOrgType } from "../../../../utils/Token";
import useFetch from "../../../../utils/useFetch";
import BaseURL from "../../../../utils/base-uri.json";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { isArray } from "lodash";

export default function ReportOnsiteOffsiteClient({ close, name }) {
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [sitedata, setSiteData] = React.useState([]);
  const [location, setLocation] = React.useState([]);
  const [token,setToken]=useState(getToken())
  useEffect(() => {
    axios
    .get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false&ClientIds=" +
    getGlobalClientId())
      .then((res) => {
        if (res.data.responseCode === 100) {
          setClient(res?.data?.data);
          if(getOrgType()=="Client"){
            setSelectValue1(res?.data?.data[0]?.value)}
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const { register } = useForm();
  const [selectValue1, setSelectValue1] = useState("");
  const [fromDateValue, setFromDateValue] = useState(null);
  const [toDateValue, setToDateValue] = useState(null);
  const changeClients = (e) => {
    setSelectValue1(e);
  };
  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };
  const { data: resp } = useFetch(
    "Client/GetBuSitesByClientId?clientId=" + selectValue1
  );
  useEffect(() => {
    if (resp?.data) {
      setSiteData(resp?.data);
    }
  }, [resp]);
  const { data: resps } = useFetch(
    "Vendor/GetEmployeesByOrgId?orgId=" + selectValue1
  );
  useEffect(() => {
    if (resps?.data) {
      setLocation(resps?.data);
    }
  }, [resps]);
  const handleFromDateChange = (event) => {
    setFromDateValue(event);
  };

  const handleToDateChange = (event) => {
    setToDateValue(event);
  };
  const [selectedsite, setSelectedsite] = useState([]);
  const [selectedlocation, setSelectedLocation] = useState([]);

  const handleDocTypeChange1 = (event) => {
    setSelectedsite(event.target.value);
  };

  const handleDocTypeChange2 = (event) => {
    setSelectedLocation(event.target.value);
  };

  const handleDateKeyDown = (e) => {
    e.preventDefault();// Prevent manual date input
 };

const headers = [
  { label: "Client Name", key: "vendorName" },
  { label: "Employee Name", key: "visitorName" },
  { label: "Security Name Checkin", key: "securityNameCheckin" },
  { label: "Last Checkin", key: "employeeCheckin" },
];
const convertToCSV = (data) => {
  const header = headers.map((header) => `"${header.label}"`).join(",");
  const rows = data.map((item) =>
    headers
      .map((header) => {
        // if (header.key === "employeeCheckin") {
        //   return `"${item[header.key]}"`;
        // }
        return `"${item[header.key]}"`;
      })
      .join(",")
  );
  return [header, ...rows].join("\n");
};
 const timeZoneOffset = new Date().getTimezoneOffset()


 const downloadCurrentlyOnsite = () => {

  axios.get("OnsiteOffsite/GetClientCurrentlyOnsite?timeZoneOffset="+timeZoneOffset).then((res) => {
    if (res?.data?.status === true) {
      if (res?.data?.data) {
        const csvContent = convertToCSV(res?.data?.data);
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "CurrentlyOnsite.csv";
        a.click();
        URL.revokeObjectURL(url);
      }
    }
  })
    .catch((err) => setError(err))
    .finally(() => {
      // setIsDownload(false);
    });
}
  return (
    <>
      <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
      <DialogContent>						
        <form
          action={
            BaseURL?.baseReportUrl+"OnsiteOffsiteClientEmployees.aspx"
          }
          method="post"
          target="_blank"
        >
          <div style={{ marginLeft: "25px" }}>
            <FormControl sx={{ m: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                {" "}
                From{" "}
              </span>
              {/* <TextField
                type="date"
                sx={{ width: "320px" }}
                name="fromDate"
                size="small"
                value={fromDateValue || ""}
                onChange={handleFromDateChange}
                onKeyDown={handleDateKeyDown}
              /> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={fromDateValue}
                  onChange={handleFromDateChange}
                  name="fromDate"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      size="small"
                      name="fromDate"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                To
              </span>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  views={["year", "month", "day"]}
                  value={toDateValue}
                  name="toDate"
                  onChange={handleToDateChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "320px",
                      }}
                      name="toDate"
                      size="small"
                      onKeyDown={handleDateKeyDown}
                    />
                  )}
                />
              </LocalizationProvider>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                Client
              </span>
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                {...register("client")}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  fontFamily: "Arial, FontAwesome",
                }}
                size="small"
                onChange={(e) => changeClients(e.target.value)}
                input={
                  <OutlinedInput
                    label="Select Client"
                    name="ClientId"
                    value={selectValue1}
                  />
                }
                MenuProps={MenuProps}
              >
                {client?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ marginLeft: 1, width: 320 }}>
              <span
                style={{
                  color: "#3E4A62",
                  fontSize: "14px",
                  fontWeight: "500",
                  marginTop: 4,
                  marginBottom: "5px",
                }}
              >
                Employees
              </span>
              <Select
                labelId="docs-label"
                id="docs-select"
                size="small"
                sx={{ width: "320px", overflow: "hidden" }}
                name="employee"
                value={selectedlocation}
                onChange={handleDocTypeChange2}
                MenuProps={MenuProps}
              >
                {location?.map((item, index) => (
                  <MenuItem key={item?.key} value={item?.key}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <input type="text" name="timeZoneOffset" value={timeZoneOffset} hidden="true" />	
          </div>
          <DialogActions>
            <div className="login-help__buttonContainer">
              <Button
                variant="contained"
                className="login-help-button-cancel"
                onClick={close}
              >
                {" "}
                Cancel
              </Button>

              {fromDateValue == "" ||
              toDateValue == "" ||
              selectValue1 == "" ||
              selectedlocation == "" ? (
                <Tooltip title="All the fields are mandatory" followCursor>
                  <span>
                    <Button
                      variant="contained"
                      className="login-button-request"
                      onClick={close}
                      disabled={
                        fromDateValue == "" ||
                        toDateValue == "" ||
                        selectValue1 == "" ||
                        selectedlocation == ""
                      }
                    >
                      Create Report
                    </Button>
                  </span>
                </Tooltip>
              ) : (
                <Button
                  variant="contained"
                  type="submit"
                  className="login-button-request"
                  onClick={close}
                >
                  Create Report
                </Button>
              )}
            </div>
          </DialogActions>
          <input type="hidden" name="token" value={token}/>
        </form>

        <br />
        <br />
      
        
          <Button
          className="mt-2 mx-3"
                  variant="contained"
                  type="submit"
             sx={{padding:"20px",width:"90%"}}
             onClick={downloadCurrentlyOnsite}
                >
                Currently Onsite Report
                </Button>
           
         
  
      </DialogContent>
    </>
  );
}
